"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../utils");
var _lodash = require("lodash");
var _richTextField = require("../../lib/richTextField");
var _CTAButton = _interopRequireDefault(require("../../components/CTAButton"));
var _linkFieldSrc = require("../../lib/linkFieldSrc");
var _imageSrc = require("../../lib/imageSrc");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/* eslint-disable jsx-a11y/img-redundant-alt */

/**
 *  A react component to create a vertical timeline
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.rendering Fields to render
 * @param {object} props.rendering.fields Fields
 *
 * @returns {React.ReactElement} A Vertical Timeline
 *
 */
function VerticalTimeline(props) {
  var _extractedFields$Imag;
  if (!props.rendering.fields) return null;
  var extractedFields = (0, _utils.extractFieldsFn)(props);
  var {
    linkUrl,
    linkTarget
  } = (0, _linkFieldSrc.linkFieldSrc)(extractedFields.Link.value);
  var {
    StepItems,
    InFocusIndicator,
    MainDescription,
    Title
  } = extractedFields;
  var activeStep = (0, _lodash.toNumber)(InFocusIndicator.value);
  var LisItem = () => (0, _lodash.map)(StepItems, (eachItem, eachKey) => {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: eachKey === activeStep ? 'active' : eachKey < activeStep ? 'complete' : undefined,
      key: eachKey
    }, /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", {
      key: eachItem.fields.StepSectionTitle.value
    }, /*#__PURE__*/_react.default.createElement("strong", null, eachItem.fields.StepSectionTitle.value)), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, (0, _richTextField.parseHTML)(eachItem.fields.StepDescription)))));
  });
  var imgUrl = (0, _imageSrc.imageHref)(extractedFields.Image.value);
  return /*#__PURE__*/_react.default.createElement("div", {
    id: (0, _utils.getComponentContentId)(props.rendering.dataSource),
    className: "app-container row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/_react.default.createElement("h2", null, Title.value), imgUrl && /*#__PURE__*/_react.default.createElement("img", {
    alt: (_extractedFields$Imag = extractedFields.Image) === null || _extractedFields$Imag === void 0 || (_extractedFields$Imag = _extractedFields$Imag.value) === null || _extractedFields$Imag === void 0 ? void 0 : _extractedFields$Imag.alt,
    src: imgUrl,
    style: {
      maxWidth: '100%'
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-8"
  }, /*#__PURE__*/_react.default.createElement("p", null, MainDescription.value), /*#__PURE__*/_react.default.createElement("ul", {
    className: "mm-vertical-timeline"
  }, /*#__PURE__*/_react.default.createElement(LisItem, null)), /*#__PURE__*/_react.default.createElement(_CTAButton.default, {
    buttonType: extractedFields.ButtonType.value,
    href: linkUrl,
    target: linkTarget,
    label: extractedFields.Text.value,
    icon: extractedFields.ctaIcon.value,
    iconDirection: extractedFields.ctaIconPlacement.value,
    dataId: extractedFields.ctaDataId.value
  })));
}
var _default = exports.default = VerticalTimeline;